import { Tag } from 'antd';
import { EnvironmentOutlined } from '@ant-design/icons';
import { useHasMultipleBuildings } from '../../hooks/useHasMultipleBuildings';

const TAG_COLORS = ['blue', 'green', 'purple', 'orange', 'cyan', 'magenta', 'geekblue', 'volcano', 'gold', 'lime'] as const;

function buildingColor(name: string): string {
	let hash = 0;
	for (let i = 0; i < name.length; i++) {
		hash = (hash * 31 + name.charCodeAt(i)) | 0;
	}
	return TAG_COLORS[Math.abs(hash) % TAG_COLORS.length];
}

interface BuildingTagProps {
	name?: string | null;
	onClick?: () => void;
	style?: React.CSSProperties;
	showIcon?: boolean;
}

export default function BuildingTag({ name, onClick, style, showIcon = true }: BuildingTagProps) {
	const showBuilding = useHasMultipleBuildings();

	if (!showBuilding || !name) return null;

	return (
		<Tag
			icon={showIcon ? <EnvironmentOutlined /> : undefined}
			color={buildingColor(name)}
			style={{
				fontSize: 14,
				fontWeight: 'normal',
				padding: '4px 12px',
				margin: 0,
				cursor: onClick ? 'pointer' : 'default',
				...style,
			}}
			onClick={onClick}
		>
			{name}
		</Tag>
	);
}
